export default __webpack_public_path__ + "static/media/inventory_icon.7242de73.svg";